import { render, staticRenderFns } from "./Signboards.vue?vue&type=template&id=74cbefd9&"
import script from "./Signboards.vue?vue&type=script&lang=js&"
export * from "./Signboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports